import React,{useState} from 'react';

import MobileMenu from './mobilemenu';
import DesktopMenu from './desktopmenu';

import {getTextWidth} from './util';
import {MenuBoundary} from './state';

const {Image} = polyphony.components.generic;
const {prefixCSS} = polyphony.css;
const {useBreakpoint, useScroll, useResize, useSelector} = polyphony.hooks;
const {withNoProps} = polyphony.hoc;

const sum = arr => arr.reduce((a, b) => a + b, 0);

const getReprWidth = (cssFont, items) => {
    let ws = items.map(x => getMaxWidth(cssFont, x));
    return ws.length > 0 ? sum(ws) / ws.length : 0;
};

const getMaxWidth = (cssFont, item) =>
    Math.max(...item.children.map(i => getTextWidth(i.title, cssFont)), getTextWidth(item.title, cssFont)) + 30;

const styles = {
    div: prefixCSS({
        top: 0,
        width: "100%",
        display: "flex",
        zIndex: 100,
        justifyContent: "space-between",
        position: 'fixed',
        transition: 'background-color 0.5s ease-in-out',
        boxSizing: 'border-box'
    }),
    a: prefixCSS({
        pointerEvents: 'auto',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        flexFlow: 'row nowrap'
    })
};

const COLOR_THRESHOLD = 200;

const HeaderBar = withNoProps(() => {
    const isMobile = useBreakpoint() === 'mobile';

    const items = useSelector(s => s.menus['navigation-menu'].items);
    const colorImage = useSelector(s => s.header_bar.color_image, (a, b) => a.id === b.id);
    const image = useSelector(s => s.header_bar.image, (a, b) => a.id === b.id);
    let paddingLeft = useSelector(s => s.measurements.header_bar_left_padding);
    let paddingRight = useSelector(s => s.measurements.header_bar_right_padding);

    const [isOpen, setOpen] = useState(false);
    const y = useScroll().y;
    const width = useResize().width;

    const percentThresholdCrossed = Math.min(y / COLOR_THRESHOLD, 1.0);
    const imagePadding = Math.max(20 * (1 - percentThresholdCrossed), 10);
    const isColor = percentThresholdCrossed === 1.0 || isOpen;
    const media = isColor ? colorImage : image;
    const headerHeight = 150 - 50 * percentThresholdCrossed;
    const logoWidth = media ? ((headerHeight - (2 * imagePadding)) / media.height) * media.width : 0; // eslint-disable-line no-extra-parens

    const availWidth = width - logoWidth - parseInt(paddingLeft) - parseInt(paddingRight);
    const uniformWidth = getReprWidth('normal 16px sans-serif', items);

    const isHamburger = isMobile || ((items.length * uniformWidth) > availWidth); // eslint-disable-line no-extra-parens

    if (isHamburger) {
        paddingLeft = 0;
        paddingRight = 0;
    }

    const divStyle = {
        ...styles.div, ...prefixCSS({
        pointerEvents: isColor ? undefined : 'none',
        backgroundColor: isColor ? 'white' : 'transparent',
        height: headerHeight,
        paddingLeft,
        paddingRight
        })
    };

    const imageStyle = prefixCSS({
        objectFit: 'fit',
        boxSizing: 'border-box',
        height: headerHeight,
        padding: imagePadding,
        width: logoWidth
    });

    return (
        <nav style={divStyle} aria-label="Primary Navigation">
            {media && <a href="/" style={styles.a} aria-label='Home' key="rootlink">
                <Image media={media} style={imageStyle} />
            </a>}
            <MenuBoundary key="boundary" value={{isColor,
                                  setOpen, isOpen,
                                  headerHeight,
                                  uniformWidth,
                                  items}}>
                {isHamburger ? <MobileMenu /> : <DesktopMenu />}
            </MenuBoundary>
        </nav>
    );
});

HeaderBar.displayName = 'HeaderBar';

export default HeaderBar;

